<template>
  <div :class="!image.file.type || image.file.type.includes('image') ? 'upload-file' : 'download-file'">
    <input
      type="file"
      @change="choseFile($event)"
      class="upload"
    />
    <div class="preview" v-if="image && image.file && image.file.url">
      <img v-if="image.file.type.includes('image')" :src="image.file.url" alt="" @click="openFile()" />
      <d-link v-else :href="image.file.url" class="files__file-icon" target="_blank">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm76.45 211.36l-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"/></svg>
      </d-link>
      <i class="fa fa-trash delete" @click="deleteFile()"></i>
    </div>
    <i class="fa fa-plus" v-else></i>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import QuotationService from '_services/rest/modules/quotation';
import { FILE } from './QuotationModel';

export default {
  name: 'Step-upload-image',
  props: {
    image: {
      type: Object,
      default: null,
    },
    fileType: {
      type: String,
      default: 'installation_local',
    },
    index: {
      type: Number,
      default: null,
    },
  },
  computed: {
    quotation() {
      const { quotation } = this.$store.state.quotation;
      if (quotation) {
        return quotation;
      }
      return {};
    },
  },
  methods: {
    ...mapActions([
      'activeAlert',
    ]),
    choseFile(event) {
      const [file] = event.target.files;
      file.url = URL.createObjectURL(file);
      this.saveFile(file);
    },
    openFile() {
      this.$emit('openLightbox');
    },
    updateEvent(image) {
      this.$emit('update:image', { image, index: this.index, type: this.fileType });
    },
    saveFile(file) {
      QuotationService.saveFile({ id: this.quotation.id, file_type: this.fileType, file })
        .then(response => {
          this.activeAlert({ message: 'Arquivo salvo com sucesso', theme: 'success' });
          this.updateEvent(response);
        });
    },
    deleteFile() {
      QuotationService.deleteQuotationFile({ quotationId: this.quotation.id, fileId: this.image.id })
        .then(() => {
          this.activeAlert({ message: 'Arquivo deletado com sucesso', theme: 'success' });
          this.updateEvent(cloneDeep(FILE));
        });
    },
  },
  mounted() { },
};
</script>

<style lang="scss" scoped>
.upload-file {
  border: 1px dashed #000;
  border-radius: 5px;
  background: #F4F5F7;
  width: 65px;
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  .preview {
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
    z-index: 5;
    img {
      width: auto;
      height: 65px;
      object-fit: contain;
    }
    .delete {
      position: absolute;
      font-size: 17px;
      color: #fff;
      bottom: 5px;
      right: 5px;
      z-index: 99;
      cursor: pointer;
    }
  }
}
.download-file {
  width: 65px;
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  svg{
    margin-bottom: 10px;
    width: 40px;
    fill: #4F5F77;
  }
  .preview {
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
    z-index: 5;

    .delete {
      position: absolute;
      font-size: 15px;
      color: #c4183c;
      bottom: 5px;
      right: 5px;
      z-index: 99;
      cursor: pointer;
      background: #fff;
      padding: 3px 4px;
      border-radius: 100%;
      box-shadow: 0px 0px 6px -1px #000;
    }
  }
}
input.upload {
  position: absolute;
  width: 100%;
  height: 100%;
  right: 0;
  z-index: 2;
  font-size: 100px; /* Aumenta tamanho do campo */
  opacity: 0;
  filter: alpha(opacity=0);
}
</style>
